import { Box, Typography } from '@mui/material';
import { Comments } from './Comments';
import { useSelector } from 'react-redux';
import { RootState } from 'shared/store/store';
import styles from './styles/CommentsSidebar.module.scss';

export const CommentsSidebar = () => {
  const commentsState = useSelector((state: RootState) => state.comments);

  return (
    <Box className={styles.commentsSidebarContainer}>
      <Box className={styles.commentsHeader}>
        <Typography variant="h6" className={styles.commentsTitle}>
          Comentarios ({commentsState.comments.length})
        </Typography>
      </Box>
      <Box className={styles.commentsContent}>
        <Comments />
      </Box>
    </Box>
  );
}; 